import React, { useContext, useEffect } from 'react';
import ProductPageContext from '../../../contexts/ProductPageContext';
import AltImageThumbnails from '../../../features/Images/AltImageThumbnails';
import useImageManager from '../../../features/Images/useImageManager';

export default function QuickviewImages({ isMobile }) {
  const ProductPageState = useContext(ProductPageContext);
  const { activeProduct } = ProductPageState?.collectionData;

  const {
    imageData,
    setImageData,
    handleImageErrorOrRemoval,
  } = useImageManager([], activeProduct?.brand);

  const showGallery = imageData?.length > 2;

  useEffect(() => {
    if (activeProduct) {
      setImageData(activeProduct.orderedImages);
    }
  }, [activeProduct, setImageData]);

  return (
    <AltImageThumbnails
      productImages={imageData}
      handleImageErrorOrRemoval={handleImageErrorOrRemoval}
      tmntData={ProductPageState.tmntData}
      singleView={!showGallery}
      isMobile={isMobile}
      hasPDPMFEBelowTheFold={ProductPageState.collectionData?.hasPDPMFEBelowTheFold}
      hasModelMeasurement={ProductPageState?.collectionData?.activeProduct?.hasFitInfo}
      activeProduct={ProductPageState.collectionData?.activeProduct}
      brand={ProductPageState.collectionData?.activeProduct?.brand}
      isQuickview={ProductPageState.quickview}
    />
  );
}
